import React from "react";
import "./SecurityFeatures.css";

function SecurityFeatures() {
  const features = [
    {
      title: "SSL Certificates",
      description: "Secure your website with trusted SSL protection.",
      icon: "🔒",
      anchor: "#security-ssl-form",
    },
    {
      title: "Domain Protection",
      description: "Prevent unauthorized changes and protect ownership.",
      icon: "🛡️",
      anchor: "#security-domain-lock-form",
    },
    {
      title: "Account Security",
      description: "Improve login safety with secure user protections.",
      icon: "👤",
      anchor: "#security-account-form",
    },
  ];

  return (
    <section className="sf-section sf-new-layout">
      <div className="sf-container">

        {/* LEFT SIDE HEADING */}
        <div className="sf-left">
          <span className="sf-badge">Core Security Services</span>

          <h2>Protection Built for Your Website & Account</h2>

          <p>
            Choose the right security solution and keep your data safe with
            powerful protection layers.
          </p>

          <div className="sf-mini-points">
            <span>🛡 100% Protection</span>
            <span>⚡ Fast Setup</span>
            <span>🔒 Secure Access</span>
          </div>
        </div>

        {/* RIGHT SIDE CARDS */}
        <div className="sf-grid">
          {features.map((item, index) => (
            <div className="sf-card" key={index}>

              <div className="sf-icon-box">
                <span>{item.icon}</span>
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>

              <a href={item.anchor} className="sf-btn">
                Get Started →
              </a>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default SecurityFeatures;